// script.js - Black Spider Slimming Capsules Landing Page Logic

document.addEventListener('DOMContentLoaded', () => {

    // 1. Live Countdown Timer (Matches prompt: 00 days : 06 hours : 43 mins : 58 secs)
    let totalSeconds = (0 * 86400) + (6 * 3600) + (43 * 60) + 58;

    function updateCountdown() {
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        const dStr = days.toString().padStart(2, '0');
        const hStr = hours.toString().padStart(2, '0');
        const mStr = minutes.toString().padStart(2, '0');
        const sStr = seconds.toString().padStart(2, '0');

        // Hero countdown
        const cDays = document.getElementById('cDays');
        const cHours = document.getElementById('cHours');
        const cMinutes = document.getElementById('cMinutes');
        const cSeconds = document.getElementById('cSeconds');

        if (cDays) cDays.textContent = dStr;
        if (cHours) cHours.textContent = hStr;
        if (cMinutes) cMinutes.textContent = mStr;
        if (cSeconds) cSeconds.textContent = sStr;

        // Promo section countdown
        const pDays = document.getElementById('pDays');
        const pHours = document.getElementById('pHours');
        const pMinutes = document.getElementById('pMinutes');
        const pSeconds = document.getElementById('pSeconds');

        if (pDays) pDays.textContent = dStr;
        if (pHours) pHours.textContent = hStr;
        if (pMinutes) pMinutes.textContent = mStr;
        if (pSeconds) pSeconds.textContent = sStr;

        if (totalSeconds > 0) {
            totalSeconds--;
        }
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);

    const checkoutButton = document.getElementById('bs-checkout-button');
    const syncCheckoutOffer = () => {
        const option = document.querySelector('input[name="bs-offer"]:checked');
        if (checkoutButton && option) checkoutButton.href = option.dataset.checkout;
    };
    document.querySelectorAll('input[name="bs-offer"]').forEach(option => {
        option.addEventListener('change', syncCheckoutOffer);
    });
    syncCheckoutOffer();
    window.addEventListener('pageshow', syncCheckoutOffer);

    // 4. FAQ Accordion
    const accordionHeaders = document.querySelectorAll('.accordion-header');
    accordionHeaders.forEach(header => {
        header.addEventListener('click', () => {
            const item = header.parentElement;
            const isActive = item.classList.contains('active');

            // Close all
            document.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('active'));

            // Toggle clicked
            if (!isActive) {
                item.classList.add('active');
            }
        });
    });

    // 5. Before & After Carousel Buttons
    const carouselTrack = document.getElementById('galleryCarousel');
    const prevBtn = document.getElementById('carouselPrev');
    const nextBtn = document.getElementById('carouselNext');

    if (carouselTrack && prevBtn && nextBtn) {
        const getScrollStep = () => {
            const item = carouselTrack.querySelector('.carousel-slide-item');
            return item ? item.offsetWidth + 20 : 300;
        };

        prevBtn.addEventListener('click', () => {
            carouselTrack.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
        });

        nextBtn.addEventListener('click', () => {
            carouselTrack.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
        });
    }

    // 7. Social Proof Live Notification Toasts
    const egyptianCustomers = [
        { name: 'محمد علي', city: 'المنيا' },
        { name: 'أحمد محمود', city: 'القاهرة' },
        { name: 'سارة إبراهيم', city: 'الجيزة' },
        { name: 'مروة عبدالفتاح', city: 'الإسكندرية' },
        { name: 'وليد خالد', city: 'المنيا' },
        { name: 'كريم عادل', city: 'أسيوط' },
        { name: 'نورهان حسن', city: 'المنصورة' },
        { name: 'صابر مختار', city: 'سوهاج' },
        { name: 'ياسمين طارق', city: 'طنطا' },
        { name: 'عبدالرحمن سكر', city: 'الزقازيق' },
        { name: 'ريماس الشرقاوي', city: 'المنيا' }
    ];

    const spToast = document.getElementById('socialProofNotification');
    const spName = document.getElementById('spCustomerName');
    const spCity = document.getElementById('spCustomerCity');

    let toastIndex = 0;
    function triggerSocialProofToast() {
        if (!spToast || !spName || !spCity) return;

        const customer = egyptianCustomers[toastIndex % egyptianCustomers.length];
        spName.textContent = customer.name;
        spCity.textContent = customer.city;

        spToast.style.display = 'flex';
        toastIndex++;

        setTimeout(() => {
            hideSocialProofToast();
        }, 5000);
    }

    window.hideSocialProofToast = function () {
        if (spToast) spToast.style.display = 'none';
    };

    // First toast after 4s, then every 12s
    setTimeout(() => {
        triggerSocialProofToast();
        setInterval(triggerSocialProofToast, 12000);
    }, 4000);

    // 8. Sticky CTA Bar Auto Hide/Show on top section
    const stickyCtaBar = document.getElementById('stickyCtaBar');
    const heroCheckout = document.getElementById('heroCheckout');

    if (stickyCtaBar && heroCheckout) {
        window.addEventListener('scroll', () => {
            const rect = heroCheckout.getBoundingClientRect();
            // Show sticky bar when scrolled past the hero area
            if (rect.bottom < 150) {
                stickyCtaBar.style.transform = 'translateY(0)';
            } else {
                stickyCtaBar.style.transform = 'translateY(100%)';
            }
        });
    }

});

// Global Image Gallery Switcher
window.changeProductImage = function (imgSrc, clickedEl) {
    const mainImg = document.getElementById('mainProductImg');
    if (mainImg) {
        mainImg.style.opacity = '0.3';
        setTimeout(() => {
            mainImg.src = imgSrc;
            mainImg.style.opacity = '1';
        }, 120);
    }

    document.querySelectorAll('.thumb-item').forEach(el => el.classList.remove('active'));
    if (clickedEl) clickedEl.classList.add('active');
};

// Global Review Modal Functions
window.openReviewModal = function () {
    const modal = document.getElementById('reviewModal');
    if (modal) modal.style.display = 'flex';
};

window.closeReviewModal = function () {
    const modal = document.getElementById('reviewModal');
    if (modal) modal.style.display = 'none';
};

// Handle Review Stars & Submission
document.addEventListener('DOMContentLoaded', () => {
    let selectedRating = 5;
    const starContainer = document.getElementById('starRatingSelect');
    if (starContainer) {
        const stars = starContainer.querySelectorAll('i');
        stars.forEach(star => {
            star.addEventListener('click', () => {
                selectedRating = parseInt(star.getAttribute('data-rating'), 10);
                stars.forEach((s, idx) => {
                    if (idx < selectedRating) {
                        s.classList.add('active');
                    } else {
                        s.classList.remove('active');
                    }
                });
            });
        });
    }

    const reviewForm = document.getElementById('writeReviewForm');
    if (reviewForm) {
        reviewForm.addEventListener('submit', (e) => {
            e.preventDefault();
            const author = document.getElementById('revAuthor').value.trim();
            const text = document.getElementById('revText').value.trim();

            if (!author || !text) return;

            const reviewsContainer = document.getElementById('reviewsContainer');
            if (reviewsContainer) {
                const newCard = document.createElement('div');
                newCard.className = 'review-item-card';

                let starHtml = '';
                for (let i = 0; i < selectedRating; i++) {
                    starHtml += '<i class="fa-solid fa-star"></i>';
                }

                newCard.innerHTML = `
                    <div class="review-card-top">
                        <div class="reviewer-data">
                            <div class="rev-avatar">${author.charAt(0)}</div>
                            <div>
                                <h4 class="rev-name">${author}</h4>
                                <div class="stars">${starHtml}</div>
                            </div>
                        </div>
                        <span class="recommend-tag"><i class="fa-solid fa-circle-check"></i> أوصي بهذا المنتج</span>
                    </div>
                    <p class="rev-body">"${text}"</p>
                `;

                reviewsContainer.insertBefore(newCard, reviewsContainer.firstChild);
            }

            reviewForm.reset();
            window.closeReviewModal();
            alert('شكراً لك! تم نشر مراجعتك بنجاح.');
        });
    }
});
